const DAYS_OF_WEEK = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

// Keyed by the `id` field of the warehouse API's error payload (BaseApiException) —
// the HTTP status itself is a plain 400 for all of these.
const SETUP_ERROR_MESSAGES = {
  'warehouse-location-layout-exists':
    'A location layout already exists for this warehouse. Enable overwrite to replace it.',
  'storage-config-exists': 'A storage config already exists for this warehouse. Enable overwrite to replace it.',
  'locations-not-found':
    'Storage areas reference locations that are not in the warehouse layout. Create the layout first.',
  'duplicated-storage-area-name': 'Storage area names must be unique.',
};

export function defaultStorageAreas() {
  return DAYS_OF_WEEK.map((name) => ({ name, locations: [] }));
}

export function warehouseSetupErrorMessage(errorId) {
  return SETUP_ERROR_MESSAGES[errorId];
}
